import { render } from "./DownloadLinkForm.vue?vue&type=template&id=4e392f1b"
import script from "./DownloadLinkForm.vue?vue&type=script&lang=ts"
export * from "./DownloadLinkForm.vue?vue&type=script&lang=ts"
script.render = render

export default script